export default __webpack_public_path__ + "static/fwwm-noise-aca68a8149949366041c243959bc96c4.gif";